/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloseDeliveriesRequest
 */
export interface CloseDeliveriesRequest {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CloseDeliveriesRequest
     */
    deliveriesToClose: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof CloseDeliveriesRequest
     */
    closedUntil: string;
}

/**
 * Check if a given object implements the CloseDeliveriesRequest interface.
 */
export function instanceOfCloseDeliveriesRequest(value: object): value is CloseDeliveriesRequest {
    if (!('deliveriesToClose' in value) || value['deliveriesToClose'] === undefined) return false;
    if (!('closedUntil' in value) || value['closedUntil'] === undefined) return false;
    return true;
}

export function CloseDeliveriesRequestFromJSON(json: any): CloseDeliveriesRequest {
    return CloseDeliveriesRequestFromJSONTyped(json, false);
}

export function CloseDeliveriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseDeliveriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deliveriesToClose': json['deliveriesToClose'],
        'closedUntil': json['closedUntil'],
    };
}

export function CloseDeliveriesRequestToJSON(json: any): CloseDeliveriesRequest {
    return CloseDeliveriesRequestToJSONTyped(json, false);
}

export function CloseDeliveriesRequestToJSONTyped(value?: CloseDeliveriesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deliveriesToClose': value['deliveriesToClose'],
        'closedUntil': value['closedUntil'],
    };
}

